import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type StopStatus = 'done' | 'problem' | 'current' | 'pending';

@Component({
  selector: 'tc-stops-track',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './stops-track.component.html',
  styleUrl: './stops-track.component.css',
})
export class StopsTrackComponent {
  stops = input.required<StopStatus[]>();
}
